"use client";

import { useMemo } from "react";
import { useGameRegistry } from "modules/common/gameRegistryContext";
import { bindFacetSearchParams } from "modules/common/parsers/searchParams";

export function useFacetSearchParamsContract() {
  const { facetContract } = useGameRegistry();
  return useMemo(() => bindFacetSearchParams(facetContract), [facetContract]);
}
